import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./DeleteConfirmModal.css";

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, isProcessing }) => {
  const { t } = useTranslation('clips');
  const [confirming, setConfirming] = useState(false);

  if (!isOpen) return null;

  const handleConfirm = async () => {
    setConfirming(true);
    try {
      await onConfirm();
    } finally {
      setConfirming(false);
    }
  };

  return (
    <div className="delete-modal-overlay" onClick={confirming ? undefined : onClose}>
      <div className="delete-modal" onClick={(e) => e.stopPropagation()}>
        <h3 className="delete-modal-title">{isProcessing ? t('cancelThisJob') : t('deleteTheseAssets')}</h3>
        <p className="delete-modal-description">
          {isProcessing ? t('willStopProcessingRemoveJob') : t('cannotBeUndone')}
        </p>
        <div className="delete-modal-actions">
          <button className="delete-modal-btn cancel" onClick={onClose} disabled={confirming}>
            {isProcessing ? t('keepGoing') : t('noKeepThem')}
          </button>
          <button className="delete-modal-btn confirm" onClick={handleConfirm} disabled={confirming}>
            {confirming ? (
              <span className="delete-modal-spinner" />
            ) : (
              isProcessing ? t('yesCancelJob') : t('yesDeleteForever')
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
